import Vue from 'vue'
import { mapState } from 'vuex'
import { CURRENCY_FIELD_BACKEND_ID } from '@/constants/currency'
import { GigTimeTypes } from '@/constants/gig/gigTimeTypes'
import Currency from '@/models-ts/Currency'
import { getCurrency } from '@/utils-ts/currencies'
import { formatUsd } from '@/utils/moneyFormat'

export default Vue.extend<any, any, any, any>({
  computed: {
    ...mapState({
      application: (state: any) => state.gigChat.application.value,
    }),
    gigModel() {
      return this.application?.gig
    },
    isHourly() {
      return this.gigModel?.timeType === GigTimeTypes.HOURLY
    },
    rate() {
      if (!this.gigModel) return '0.00'

      return formatUsd(this.gigModel?.rate)
    },
    prefferedCurrencies() {
      if (!this.gigModel) return []

      const currencies = this.gigModel.currencies
      return currencies
        .map((curr: any) => getCurrency({ blockchain: curr.blockchain, value: curr.currency, field: CURRENCY_FIELD_BACKEND_ID }))
        .filter(Boolean)
    },
    formattedCurrencies() {
      return this.prefferedCurrencies
        .slice(0, 3)
        .map((curr: Currency) => curr.name)
        .join(', ')
    },
    timeValue() {
      return this.gigModel?.timeValue
    },
  },
})
